import { render, staticRenderFns } from "./UserProfileChangeLogList.vue?vue&type=template&id=322c1e3c&scoped=true"
import script from "./UserProfileChangeLogList.vue?vue&type=script&lang=js"
export * from "./UserProfileChangeLogList.vue?vue&type=script&lang=js"
import style0 from "./UserProfileChangeLogList.vue?vue&type=style&index=0&id=322c1e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322c1e3c",
  null
  
)

export default component.exports